import React, { useEffect, useMemo, useState } from 'react'
import { Box, TextField, Button, Grid, FormControl, InputLabel, Select, MenuItem, 
} from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import { useSnackbar } from 'notistack';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { addAdmin, updateAdmin, getAdminRoles } from 'services/admin';

const AddAdmin = ({ adminData, onSuccess, onFailure }) => {

  const defaultFormFields = useMemo(() => ({
    firstName: '',
    lastName: '',
    mobile: '',
    email: '',
    roles:'',
  }),[]);

 
  const { enqueueSnackbar } = useSnackbar();
  const [roles, setRoles] = useState([]);
  const { handleSubmit, control, formState: { errors }, reset } = useForm({
    mode: 'onTouched',
    defaultValues: {...defaultFormFields}
  });

  useEffect(() => {
    getAdminRolesList();
  }, []);
  

  useEffect(() => {
    if(adminData){
      const data = {
        firstName: adminData?.firstName,
        lastName: adminData?.lastName,
        mobile: adminData?.mobile,
        email: adminData?.email,
        roles: Array.isArray(adminData?.roles) ? adminData?.roles[0] : (adminData?.roles || ''),
      }
      reset({...data});
    }
  }, [adminData, reset]);

  const resetForm = () => {
    reset({...defaultFormFields});
  };

  const onSubmit = (data) => {
    if(adminData){
      updateAdminDetails(data);
    }else{
      saveAdminDetails(data);
    }
  }

  const saveAdminDetails = (data) => {
    addAdmin({
      ...data,
      roles: [data.roles],
      ...(adminData?.userId ? {userId: adminData?.userId} : {})
    }).then(({response, error}) => {
      if(response){
        enqueueSnackbar((`Admin updated successfully`), {variant: 'success'});
        resetForm();
        onSuccess()
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
        onFailure()
      }
    });
  }

  const updateAdminDetails = (data) => { 
    updateAdmin({
      ...data,
      roles: [data.roles],
      ...(adminData?.userId ? {userId: adminData?.userId} : {})
    }).then(({response, error}) => {
      if(response){
        enqueueSnackbar((`Admin updated successfully`), {variant: 'success'});
        resetForm();
        onSuccess()
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
        onFailure()
      }
    });
  }

  const getAdminRolesList = (data) => { 
    getAdminRoles().then(({response, error}) => {
      if(error){
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      } else {
        setRoles([...response]);
      }
    });
  }

  return (
    <Box noValidate component="form"  onSubmit={handleSubmit(onSubmit)} sx={{ mt: 1 }} >
      <Grid container columnSpacing={2} rowSpacing={2} justifyContent="center">
        <Grid  item xs={12} sm={12} md={12} lg={12}>
          <Controller
            control={control}
            name="firstName"
            id="firstName"
            rules={{ required: "Enter first name" }}
            render={({field}) => (
              <TextField
                {...field}
                margin="normal"
                label="First Name"
                required
                error={!!errors?.firstName}
                size="small"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid  item xs={12} sm={12} md={12} lg={12}>
          <Controller
            control={control}
            name="lastName"
            id="lastName"
            rules={{ required: "Enter last name" }}
            render={({field}) => (
              <TextField
              {...field}
                margin="normal"
                label="Last Name"
                required
                error={!!errors?.lastName}
                size="small"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Controller
            control={control}
            name="mobile"
            id="mobile"
            rules={{ required: "Enter mobile number",
            pattern: {
              value: /^[0-9]{10}$/i,
              message: "Enter a valid 10 digit registered mobile number",
            },
          }}
          render={({field}) => (
              <TextField
                {...field}
                margin="normal"
                label="Mobile"
                required
                error={!!errors?.mobile}
                helperText={errors.mobile?.message}
                size="small"
                fullWidth
                // InputProps={{
                //   endAdornment: <InputAdornment position="start">%</InputAdornment>,
                // }}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Controller
            control={control}
            name="email"
            id="email"
            rules={{ required: "Enter email",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
              message: "Enter a valid email address",
            },
          }}
          render={({field}) => (
              <TextField
                {...field}
                margin="normal"
                label="Email"
                required
                error={!!errors?.email}
                helperText={errors.email?.message}
                size="small"
                fullWidth
                // InputProps={{
                //   endAdornment: <InputAdornment position="start">%</InputAdornment>,
                // }}
              />
            )}
          />
        </Grid>

        <Grid  item xs={12} sm={12} md={12} lg={12}>
          <Controller
            control={control}
            name="roles"
            id="roles"
            rules={{ required: "Select role" }}
            render={({field}) => (
              <FormControl {...field} required fullWidth error={!!errors?.roles}>
                <InputLabel id="role-input-label" size="small">Role</InputLabel>
                <Select
                  labelId="role-label"
                  id="role-select-id"
                  label="Role"
                  name="roles"
                  required
                  size="small"
                  value={field.value || ''}
                  onChange={field.onChange}
                >
                   {roles.map(({role, roleId}, index) => <MenuItem key={roleId} value={role}>{role}</MenuItem>)}
                </Select>
              </FormControl>
            )}
          />
        </Grid>
          
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Button
            type="submit"
            variant="contained"
            sx={{ mt: 3, mb: 2, textTransform: 'inherit' }}
            startIcon={adminData ? <ModeEditIcon /> : <ControlPointIcon />} 
            color="primary"
          >
            {adminData ? 'Update' : 'Add'}
          </Button>
        </Grid>


        </Grid>
    </Box>
  );
}
 
export default React.memo(AddAdmin);
